// Process-wide "the organization's subscription is locked" signal.
//
// Namespace-scoped endpoints answer 402 { error: "subscription_locked" } when
// the org is locked (docs/plan/stripe-subscriptions.md, Appendix A). The API
// clients report that here instead of surfacing a generic request error, and
// the SubscriptionLockGate subscribes so the full-screen lock page appears no
// matter which query tripped it. Kept in its own module so both api-client
// and the billing hooks can import it without a circular dependency.

const listeners = new Set<(locked: boolean) => void>();
let locked = false;

export function isSubscriptionLocked(): boolean {
  return locked;
}

export function markSubscriptionLocked(): void {
  if (locked) return;
  locked = true;
  listeners.forEach((listener) => listener(true));
}

/** Clears the flag, e.g. after the subscription query reports the org is active again. */
export function clearSubscriptionLocked(): void {
  if (!locked) return;
  locked = false;
  listeners.forEach((listener) => listener(false));
}

export function subscribeToSubscriptionLock(listener: (locked: boolean) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Test helper: resets the flag without notifying listeners. */
export function resetSubscriptionLockForTests(): void {
  locked = false;
}
